import React, { useState, useEffect, useCallback } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

import Icon from 'discada/dist/Icon'
import Button from 'discada/dist/Button'

import { getQuoteValue } from 'selectors/quoteSelectors'

import tpLogo from 'static/images/tpLogo.png'
import {
  getRooftopWebsite,
  getTaggedCustomerFromState,
} from 'selectors/appStatusSelectors'
import { getCustomerZip } from 'selectors/naughtySelectors'
import { updateTrade } from 'actions/naughtyActions'

import { getReportLinkUrl, getTradeReport, getReportValues } from 'utils/trade'
import { moneyShort, numShort } from 'utils'
import { getRooftopName } from 'selectors/appStatusSelectors'
import { addToPageState } from 'actions/pageStateActions'

import { MODES } from 'components/Quote/Trades'

export function TradePendingReportNewPreso(props) {
  let {
      trade = {},
      id,
      zipCode,
      className,
      updateTrade,
      mileage,
      dealerWebsite,
      createChangeEvent,
      toggleMode,
      rooftopName,
      addToPageState,
      mode,
    } = props,
    [loading, setLoading] = useState(false),
    [tradeIndex, setTradeIndex] = useState(props.tradeIndex),
    [reportUrl, setReportUrl] = useState(),
    confirmed = get(trade, 'confirmed'),
    reportValues = getReportValues(trade)

  useEffect(() => {
    setReportUrl(getReportLinkUrl({ dealerWebsite, zipCode, trade }))
  }, [dealerWebsite, trade, zipCode])

  useEffect(() => {
    setTradeIndex(props.tradeIndex)
  }, [props.tradeIndex])

  useEffect(() => {
    if (id && zipCode && mileage && trade.confirmed) {
      setLoading(true)

      getTradeReport({
        dealerWebsite,
        vehicleId: id,
        zipCode,
        mileage,
      })
        .then(({ data }) =>
          updateTrade(
            tradeIndex,
            { tradePending: { report: data.report, vehicle: data.vehicle } },
            {
              clean: true,
              dirty: false,
              createChangeEvent,
              clearTrade: trade.id !== get(data, 'vehicle.id'),
            },
          ),
        )
        .finally(() => setLoading(false))
    }
  }, [
    createChangeEvent,
    dealerWebsite,
    id,
    mileage,
    tradeIndex,
    updateTrade,
    zipCode,
    trade.id,
    trade.confirmed,
  ])

  if (!id) return null

  let loadingContent = (
      <span className="tp-loading-wrapper">Getting values...</span>
    ),
    reportContent = (
      <span className="tp-report-link">
        <span>
          <strong className="mode-change" onClick={toggleMode}>
            {numShort(mileage)}
          </strong>{' '}
          miles, Value:{' '}
          <strong>
            {isEmpty(reportValues)
              ? 'Unavailable'
              : reportValues.map(moneyShort).join('-')}
          </strong>
        </span>
      </span>
    ),
    renderContent = () => {
      if (mode === MODES.search) {
        return null
      } else if (loading) {
        return loadingContent
      } else {
        return reportContent
      }
    }

  return (
    <div
      className={c('tp-report-inner', className, {
        'has-allowance': !isEmpty(reportValues),
      })}
    >
      {renderContent()}
      <span className="tp-logo-wrapper">
        <a href={reportUrl} target="_blank" rel="noopener noreferrer">
          Powered by <img src={tpLogo} alt="powered by TradePending" />
        </a>
      </span>

      {mode === MODES.values && confirmed && (
        <div className="sell-button-wrapper">
          <Button
            icon="money-bill-wave"
            link
            rounded
            size="small"
            className="list-control"
            onClick={() => {
              addToPageState({ reaction: 'getOTD', step: 'sellMyTrade' })
            }}
          >
            <strong>Sell my car</strong> to {rooftopName}
          </Button>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state, op) {
  let customer = getTaggedCustomerFromState(state),
    zipCode = getCustomerZip(state),
    trade = getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      `trades[${op.tradeIndex}]`,
      {},
    ),
    { id, mileage } = trade

  return {
    ...op,
    trade,
    id,
    mileage,
    zipCode,
    customer,
    dealerWebsite: getRooftopWebsite(state),
    rooftopName: getRooftopName(state),
  }
}

export const TradePendingReportNew = connect(
  mapStateToProps,
  { updateTrade, addToPageState },
)(TradePendingReportNewPreso)

export default TradePendingReportNew
